const state = {
  keyword: '333'
};
const mutations = {
  setKeyword (state, key) {
    state.keyword = key;
  }
};

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js